// src/components/Magazine/Michelangelo.js
import React, {useState} from 'react';
import CloseIcon from '@mui/icons-material/Close';

import '../../styles/magazineGallery.scss';

function MeganNextGen() {
  /*Costruire react things */
    let data=[
        {
            id: 1,
            imgSrc: '/images/MeganNextGen/Megan1.jpg',
        },
        {
            id: 2,
            imgSrc: '/images/MeganNextGen/Megan2.jpg',
        },
        {
            id: 3,
            imgSrc: '/images/MeganNextGen/Megan3.jpg',
        },
        {
            id: 4,
            imgSrc: '/images/MeganNextGen/Megan4.jpg',
        },
        {
            id: 5,
            imgSrc: '/images/MeganNextGen/Megan5.jpg',
        },
        {
            id: 6,
            imgSrc: '/images/MeganNextGen/Megan6.jpg',
        },
      
        
    ]
    const [model, setModel] = useState(false);
    const [tempimgSrc, setTempImgSrc] = useState('');
    const getImg = (imgSrc) =>{
        setTempImgSrc(imgSrc);
        setModel(true);
    }
  return (
    <>
    <div className={model ? "model open" : "model"}>
        <img src={tempimgSrc} alt="MeganNextGen" />
        <CloseIcon onClick={()=> setModel(false)} />
    </div>
        <div className="gallery">
            {data.map((item, index)=>{
                return(
                    <div className='pics' key={index} onClick={()=> getImg(item.imgSrc)}>
                        <img src={item.imgSrc} alt="MeganNextGen" style={{width: '100%'}} loading="lazy"  />
                     </div>
                )
            })}
        </div>
     
    </>
  );
}

export default MeganNextGen;
